import React from 'react';

class Button extends React.Component{

    static defaultProps = {
        large: false,
        small: false,
        outline: false,
        context: "info",
        content: "Text",
        className: "",
    };
    
    render(){
        const { context, large, small, content, outline, className } = this.props;
        return (
            <button type="button" className={'btn '+className+' '+(large?'btn-lg':null)+' '+(small?'btn-sm':null)+' '+(outline?'btn-outline-'+context:'btn-'+context)}>{this.props.children||content}</button>
        );
    }
}

export default Button;
